module.exports = __webpack_public_path__ + "img/blog-anti-delete-settings.da7fc37c.webp";